import React, {Component} from 'react';
import config from 'react-global-configuration';
import axios from "axios";
import $ from 'jquery';
import {Nav, Navbar, NavItem} from "react-bootstrap";
import {Collapse, Label, Button, Input, Form, FormGroup, Modal, ModalBody, ModalFooter, ModalHeader} from 'reactstrap';
//import Select from 'react-select';
import 'datatables.net';
import 'datatables.net-responsive';
import "../assets/css/datatables/datatables.min.css";
import {css} from '@emotion/core';
import {BeatLoader} from 'react-spinners';
import NotificationSystem from "react-notification-system";
import {style} from "variables/Variables.jsx";
import '../assets/css/react-confirm-alert/react-confirm-alert.css';
import ReactTooltip from 'react-tooltip';
import {Link} from 'react-router-dom';
import jwt_decode from "jwt-decode";
import Select from 'react-select';
import moment from 'moment';
import CommonNavbar, {navbar} from "./commonNavbar";
import ReactMultiSelectCheckboxes from 'react-multiselect-checkboxes';
import {List} from 'react-virtualized';

const override = css`
    display: block;
    margin: 0 auto;
    border-color: red;
`;

class AdminPromotionMasterBackend extends Component {
  constructor(props) {
    super(props);
    this.state = {
      unmapped_files: [],
      unmappedData: {
        id: '',
        user_id: '',
        file_name: '',
        file_path: '',
        timestamp: '',
        version: '',
        cur_version: '',
        status: '',
        user_type: ''
      },
      unmappedModel: false,
      data: [],
      loading: true,
      _notificationSystem: null,
      versions: [],
      tableLists: [],
      newRelationModel: false,
      deleteKeys: [],
      user_id: null,
      map_status: null,
      stored_file_name: null,
      file_name: null,
      userGroup: null,
      id: null,
      campaign_response: [],
      emiMenus: [],
      party_master_id: null,
      party_options: [
        {value: 'Brand', label: 'Brand'},
        {value: 'Merchant', label: 'Merchant'},
      ],
      party_list: [],
      selected_party_type: null,
      selected_party: null,
      selected_party_type2: null,
      selected_party2: null,
      upload_user_type: null,
      partyTypeID: '',
      partyTypeValue: null,
      partyID: '',
      partyValue: null,
      files_data: null,
      bank_files: [],
      brand_files: null,
      innoviti_files: null,
      merchant_files: [],
      campaignConfirmationModel: false,
      promotion_id: null,
      selectedFile1: null,
      selectedFile2: null,
      selectedFile3: null,
      selectedFile4: null,
      bank_count: 0,
      merchant_count: 0,
      merchant_files_out: [],
      bank_files_out: [],
      new_it: 0,
      new_to: 0,
      upload_disabler: false,
      displaySchemeDiv: "none",
      enableDisablePartyType: 'none'
    };
  }

  handleNotificationClick = (position, color, msg) => {
    var level;
    switch (color) {
      case 1:
        level = "success";
        break;
      case 2:
        level = "warning";
        break;
      case 3:
        level = "error";
        break;
      case 4:
        level = "info";
        break;
      default:
        break;
    }
    this.state._notificationSystem.addNotification({
      title: <span data-notify="icon" className="pe-7s-gift"/>,
      message: (
        <div>
          {msg}
        </div>
      ),
      level: level,
      position: position,
      autoDismiss: 5
    });
  };

  componentDidMount() {
    this._refreshCampaign();
    //this.getPartyID();
    this.getPartyList();
    this.setState({_notificationSystem: this.refs.notificationSystem});
    var _notificationSystem = this.refs.notificationSystem;
  }

  // getPartyID(){
  //     if ($.fn.DataTable.isDataTable('#party_showTable')) {
  //         $('#party_showTable').DataTable().destroy();
  //     }
  //     const token = localStorage.usertoken;
  //     const decoded = jwt_decode(token);
  //     console.log(decoded.userGroup);

  //     axios.get(config.get('API_URL') + '/brandemi/get_party_id',{
  //         headers: {
  //             Authorization: ` ${localStorage.usertoken}`
  //         },
  //         params: {
  //             user_id: decoded._id,
  //         }
  //     }).then(response => {
  //         if(response.data.length == 0 && (decoded.userGroup == 1 || decoded.userGroup == '1')){
  //             this.setState({
  //                 party_master_id: 3,
  //                 loading: false,
  //                 user_id: decoded._id
  //             }, () => {
  //                 //this._refreshCampaign();
  //             });

  //         }
  //         else{
  //             response.data.map((values, index) => {
  //                 console.log(values.party_id);
  //                 this.setState({
  //                     party_master_id: values.party_id,
  //                     loading: false,
  //                     user_id: decoded._id,
  //                     selected_party: this.state.party_master_id,
  //                     party_id_mapper: response.data
  //                 }, () =>{
  //                     this._refreshCampaign();
  //                 })
  //             })
  //             $('#party_showTable').DataTable();
  //         }
  //         //console.log(response.data);
  //     });

  // }

  setDescription = (optionSelected) => {
    this.setState({selectedDescription: optionSelected});
    //console.log(this.state.selectedDescription)
  };
  updateSKU = (optionSelected) => {
    this.setState({selectedSKU: optionSelected.value})
  };
  updatePrice = (optionSelected) => {
    this.setState({selectedPrice: optionSelected.value})
  };

  openActivateConfirmation = (status) => {
    this.setState({
      mapFieldCampaign: status,
      campaignConfirmationModel: !this.state.campaignConfirmationModel
    });
  }

  toggleCampaignModel() {
    this.setState({
      campaignConfirmationModel: !this.state.campaignConfirmationModel
    });
  }

  checkMimeType = (event) => {
    //getting file object
    var files = event.target.files
    //define message container
    var err = ''
    // list allow mime type
    const types = ['image/png', 'image/jpeg', 'text/plain', 'application/zip', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document', 'application/msword', 'text/csv', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'application/vnd.ms-excel', 'application/pdf', 'message/rfc822']
    // loop access array
    for (var x = 0; x < files.length; x++) {
      //console.log(files[x]);
      if (types.every(type => files[x].type !== type)) {
        // create error message and assign to container
        err += files[x].type + ' is not a supported format\n';
      }
    }
    ;

    if (err !== '') { // if message not same old that mean has error
      event.target.value = null // discard selected file
      //console.log(err)
      this.handleNotificationClick("tr", 3, "Upload only valid file formats");
      return false;
    }
    return true;

  }

  onChangeHandler1 = event => {
    //console.log(event.target.name)
    var files = event.target.files[0]
    var files1 = event.target.files;
    if (files1.length == 0) {
      this.setState({
        selectedFile1: null
      })
    } else {
      if (this.checkMimeType(event)) {
        // if return true allow to setState
        this.setState({
          selectedFile1: files,
          upload_it: true
        })
      } else {
        this.setState({
          selectedFile1: null,
          upload_it: false
        })
      }
    }
  }

  onChangeHandler2 = event => {
    var files = event.target.files[0]
    var files1 = event.target.files;
    if (files1.length == 0) {
      this.setState({
        selectedFile2: null
      })
    } else {
      if (this.checkMimeType(event)) {
        // if return true allow to setState
        this.setState({
          selectedFile2: files,
          upload_it: true
        })
      } else {
        this.setState({
          selectedFile2: null,
          upload_it: false
        })
      }
    }
  }

  onChangeHandler3 = (index, event) => {
    var files = event.target.files
    if (files.length == 0) {
      this.setState({
        selectedFile3: {...this.state.selectedFile3, [index]: null}
      })
    } else {
      if (this.checkMimeType(event)) {
        // if return true allow to setState
        this.setState({
          selectedFile3: {...this.state.selectedFile3, [index]: files},
          upload_it: true
        })
      } else {
        this.setState({
          selectedFile3: {...this.state.selectedFile3, [index]: null},
          upload_it: false
        })
      }
    }
  }

  onChangeHandler4 = (index, event) => {
    var files = event.target.files;
    //console.log(files.length);
    if (files.length == 0) {
      this.setState({
        selectedFile4: {...this.state.selectedFile4, [index]: null}
      })
    } else {
      if (this.checkMimeType(event)) {
        // if return true allow to setState
        this.setState({
          selectedFile4: {...this.state.selectedFile4, [index]: files},
          upload_it: true
        })
      } else {
        this.setState({
          selectedFile4: {...this.state.selectedFile4, [index]: null},
          upload_it: false
        })
      }
    }
  }


  toggleunmappedModel() {
    this.setState({
      unmappedModel: !this.state.unmappedModel
    })
  }

  // campaignDropdown = () => {
  //     const token = localStorage.usertoken;
  //     const decoded = jwt_decode(token);
  //     if (this.state.partyValue != null){
  //         if(this.state.partyValue.length > 1){
  //             this.handleNotificationClick("tr", 3, "Select only one party");
  //         }
  //         else if(this.state.partyValue.length == 1){
  //             var checker = this.state.partyValue;
  //             if (checker[0].value1 == 'Merchant'){
  //                 this.handleNotificationClick("tr", 3, "Promotion creation for merchant currently unavailable");
  //             }
  //             else{
  //                 this.state.partyValue.map((valuer, index) => {
  //                     this.setState({
  //                         party_master_id: valuer.value,
  //                         upload_user_type: 7,
  //                         uploadDropdown: true
  //                     }, () =>{
  //                         this.props.history.push('/admin/admin-create-promotion/' + this.state.party_master_id);
  //                     })
  //                 })
  //             }
  //         }
  //     }
  //     else{
  //         this.handleNotificationClick("tr", 3, "Select atleast one party");
  //     }
  // }

  campaignDropdown = () => {
    this.props.history.push('/admin/admin-create-promotion1');
  }


  // _refreshCampaign() {
  //     if ($.fn.DataTable.isDataTable('#campaignTable')) {
  //         $('#campaignTable').DataTable().destroy();
  //     }

  //     const token = localStorage.usertoken;
  //     const decoded = jwt_decode(token);
  //     if(decoded.userGroup == 1 && decoded.userSubGroup == 10){
  //         axios.post(config.get('API_URL') + '/brandemi/get_promotion_master_filter_configure', {
  //             party_type: this.state.partyTypeID,
  //             party_id: this.state.partyID
  //         }, {
  //             headers: {
  //                 Authorization: ` ${localStorage.usertoken}`
  //             }
  //         }).then(response => {
  //             //console.log(response);
  //             this.setState({
  //                 campaign_response: response.data.data
  //             });
  //             $('#campaignTable').DataTable({
  //                 "oLanguage": {
  //                     "sEmptyTable": "No approved promotions present"
  //                 }
  //             });
  //             this.setState({
  //                 loading: false
  //             })

  //         });
  //     }
  //     else{
  //         axios.post(config.get('API_URL') + '/brandemi/get_promotion_master_filter', {
  //             party_type: this.state.partyTypeID,
  //             party_id: this.state.partyID
  //         }, {
  //             headers: {
  //                 Authorization: ` ${localStorage.usertoken}`
  //             }
  //         }).then(response => {
  //             //console.log(response);
  //             this.setState({
  //                 campaign_response: response.data.data
  //             });
  //             $('#campaignTable').DataTable({
  //                 "oLanguage": {
  //                     "sEmptyTable": "You have not created any promotions"
  //                 }
  //             });

  //             this.setState({
  //                 loading: false
  //             })

  //         });
  //     }
  // }

  _refreshCampaign() {

    const that = this;
    const token = localStorage.usertoken;
    const decoded = jwt_decode(token);
    var stringCode = decoded.object_code;
    var arrayCode = stringCode.split(",");
    if ($.fn.DataTable.isDataTable('#campaignTable')) {
      $('#campaignTable').DataTable().destroy();

    }

    var vEmiFlexyEndPoint = '';
    var vLocEmiType = localStorage.getItem('locPromoFlexipay');

    if (vLocEmiType === '1') {
      vEmiFlexyEndPoint = "promotion_master_filter_paginate_flexipay";
    } else {
      vEmiFlexyEndPoint = "promotion_master_filter_paginate";
    }
    console.log(vEmiFlexyEndPoint);

    var data = {
      party_type: this.state.partyTypeID,
      party_id: this.state.partyID
    }
    var schemeList = $('#campaignTable').DataTable(
      {
        order: [],
        "processing": true,
        "serverSide": true,
        "bDestroy": true,
        "paging": true,
        "pageLength": 20,
        "bInfo": true,
        "autoWidth": false,
        "responsive": false,
        "scrollX": true,
        "lengthMenu": [[20, 50, 100, 500 - 1], [20, 50, 100, 500, "All"]],

        ajax: {
          url: config.get('API_URL') + "/brandemi/" + vEmiFlexyEndPoint,
          type: "POST",
          data: data,
          dataSrc: function (json) {
            console.log(json.data);
            return json.data;
          },
          beforeSend: function (request) {
            request.setRequestHeader("Authorization", localStorage.usertoken);
          },
          error: function (request, status, error) {
            console.log('error pramotion');
            console.log(error);
          }
        },

        columns: [
          {"data": "party_type"},
          {"data": "party_name"},
          {"data": "campaign_name"},
          {"data": "campaign_desc"},
          {"data": "start_date"},
          {"data": "end_date"},
          {"data": "record_update_timestamp"},
          {"data": "active"},
          {"data": "id"}
        ],
        "columnDefs": [
          // {

          //     "className":"text-center",
          //     "targets": 5,
          //     "data": "data",
          //     "createdCell": (td, cellData, rowData, row, col) => {
          //         $(td).text('');

          //         if(rowData.org==null || rowData.org=='null' || rowData.org=='') {
          //             $(td).text('');

          //         }
          //         else {
          //             var n = rowData.org.split(",").length;
          //             if (n > 1) {
          //                 var trimmedString = rowData.org.split(",")[0];
          //                 $(td).append(trimmedString + ' <a href="#"  data-tip="Stop" title="View" id="View"  class="" >View All..</a>');
          //                 $(td).click(e => {
          //                     this.toggleNewOrgModel(e, rowData.org);
          //                 })
          //             } else {
          //                 $(td).append(rowData.org );

          //             }
          //         }
          //     },
          //     bSortable: false,
          // },
          {
            "width": "10%",
            render: function (data, type, row) {
              var id = row.id;
              var unipaynext = "UnipayNext_" + id;
              var TotalEMI = "TotalEMI_" + id;
              var TrueEMI = "TrueEMI_" + id;
              var ALL = "ALL_" + id;

              // var strArray = data.split("_");
              // var id = strArray[8];
              // var status = strArray[1];
              // var active = '';
              // var unlock_icon = '';
              // if (status == 'active') {
              //     active = 'checked';
              // }
              // if(row.event=='account_locked' || row.login_attempts>4){
              //     unlock_icon = '<a href="#" data-tip="Unlock" data-id="' + id + '" class="btn btn-default actionBtn btn-delet" role="button" >' +
              //         '<i class="fa fa-unlock" aria-hidden="true"></i>' +
              //         '</a>';
              // }
              // return '<td ><a href="#" data-tip="Edit" data-id="' + id + '" class="btn btn-default actionBtn btn-edit" role="button">' +
              //     '<span class="glyphicon glyphicon-edit" aria-hidden="true"></span></a>&nbsp;     ' +
              //     '<a href="#" data-tip="Delete" data-id="' + id + '" class="btn btn-default actionBtn btn-delet" role="button" >' +
              //     '<span class="glyphicon glyphicon-remove" aria-hidden="true"></span>' +
              //     '</a>' +
              //     '<label class="switch">' +
              //     '<input type="checkbox" data-id="' + id + '" data-status="' + status + '" class="user_status" ' + active + '>' +
              //     '<span class="slider round"></span>' +
              //     '</label>' + unlock_icon
              //     +
              //     '</td>';
              // return '<td><ReactTooltip className="actionTooltip" place="bottom" type="dark" effect="solid"/>'+
              //         '<Link className="viewButton" data-tip="View Scheme"  to="/admin/admin-new-create-schemes-view/' + id + '"><span className="glyphicon glyphicon-eye-open" aria-hidden="true"></span></Link>' +
              //         '<Link className="viewButton" data-tip="Edit Scheme"  to="/admin/admin-new-create-schemes-edit/' + id + '"><span className="glyphicon glyphicon-edit" aria-hidden="true"></span></Link>' +
              //         '</td>';
              if (row.active == 'Created') {
                return '<td>' +
                  '<a class="viewButton" data-tip="View Promotion" href="/admin/admin-view-promotion1/' + id + '">' +
                  '<span class="glyphicon glyphicon-eye-open" aria-hidden="true">' +
                  '</span>' +
                  '</a>' +
                  '<a class="viewButton" data-tip="Edit Promotion" href="/admin/admin-edit-promotion/' + id + '">' +
                  '<span class="glyphicon glyphicon-edit" aria-hidden="true">' +
                  '</span>' +
                  '</a>' +
                  '<div class="__react_component_tooltip place-bottom type-dark " data-id="tooltip">' +
                  '</div>' +

                  '</td>';
              }
                // else if (row.active == 'Automated'){

                //     return '<td>'+
                //         '<a class="viewButton" data-tip="View Promotion" href="/admin/admin-view-promotion1/' + id + '" currentitem="false">' +
                //         '<span class="glyphicon glyphicon-eye-open" aria-hidden="true">' +
                //         '</span>' +
                //         '</a>' +
                //         '<div class="__react_component_tooltip place-bottom type-dark " data-id="tooltip">'+
                //         '</div>' +
                //         '<select name="emi_type" id="my-select"'+(row.emi_type !== null ? 'disabled="disabled"' : '')+'>'+
                //         '<option value="">Select EMI Type</option>'+
                //         '<option value="'+ALL+'"'+(row.emi_type === "ALL" ? 'selected="selected"' : '')+'>All</option>'+
                //         '<option value="'+unipaynext+'"'+(row.emi_type === "UnipayNext_" ? 'selected="selected"' : '')+'>UnipayNext</option>'+
                //         '<option value="'+TotalEMI+'"'+(row.emi_type === "TotalEMI" ? 'selected="selected"' : '')+'>TotalEMI</option>'+
                //         '<option value="'+TrueEMI+'"'+(row.emi_type === "TrueEMI" ? 'selected="selected"' : '')+'>TrueEMI</option>'+
                //         '</select>'+
                //         '</td>';
              // }
              else {

                return '<td>' +
                  '<a class="viewButton" data-tip="View Promotion" href="/admin/admin-view-promotion1/' + id + '" currentitem="false">' +
                  '<span class="glyphicon glyphicon-eye-open" aria-hidden="true">' +
                  '</span>' +
                  '</a>' +
                  '<a class="viewButton" data-tip="Clone Promotion" href="/admin/admin-clone-promotion/' + id + '">' +
                  '<span class="glyphicon glyphicon-paste" aria-hidden="true">' +
                  '</span>' +
                  '</a>' +
                  '<div class="__react_component_tooltip place-bottom type-dark " data-id="tooltip">' +
                  '</div>' +

                  '</td>';
              }
            },
            className: "action_button",
            targets: 8,
            aTargets: [-1]
          },
          // {
          //     "width": "10%",
          //     render: function (data, type, row) {
          //         var id = row.id;
          //         // var strArray = data.split("_");
          //         // var id = strArray[8];
          //         // var status = strArray[1];
          //         // var active = '';
          //         // var unlock_icon = '';
          //         // if (status == 'active') {
          //         //     active = 'checked';
          //         // }
          //         // if(row.event=='account_locked' || row.login_attempts>4){
          //         //     unlock_icon = '<a href="#" data-tip="Unlock" data-id="' + id + '" class="btn btn-default actionBtn btn-delet" role="button" >' +
          //         //         '<i class="fa fa-unlock" aria-hidden="true"></i>' +
          //         //         '</a>';
          //         // }
          //         // return '<td ><a href="#" data-tip="Edit" data-id="' + id + '" class="btn btn-default actionBtn btn-edit" role="button">' +
          //         //     '<span class="glyphicon glyphicon-edit" aria-hidden="true"></span></a>&nbsp;     ' +
          //         //     '<a href="#" data-tip="Delete" data-id="' + id + '" class="btn btn-default actionBtn btn-delet" role="button" >' +
          //         //     '<span class="glyphicon glyphicon-remove" aria-hidden="true"></span>' +
          //         //     '</a>' +
          //         //     '<label class="switch">' +
          //         //     '<input type="checkbox" data-id="' + id + '" data-status="' + status + '" class="user_status" ' + active + '>' +
          //         //     '<span class="slider round"></span>' +
          //         //     '</label>' + unlock_icon
          //         //     +
          //         //     '</td>';
          //         // return '<td><ReactTooltip className="actionTooltip" place="bottom" type="dark" effect="solid"/>'+
          //         //         '<Link className="viewButton" data-tip="View Scheme"  to="/admin/admin-new-create-schemes-view/' + id + '"><span className="glyphicon glyphicon-eye-open" aria-hidden="true"></span></Link>' +
          //         //         '<Link className="viewButton" data-tip="Edit Scheme"  to="/admin/admin-new-create-schemes-edit/' + id + '"><span className="glyphicon glyphicon-edit" aria-hidden="true"></span></Link>' +
          //         //         '</td>';
          //         if(row.active == '1' || row.active == 1){
          //             return '<td>Yes</td>';
          //         }
          //         else{
          //             return '<td>No</td>'
          //         }
          //     },
          //     className: "action_button",
          //     targets: 7,
          //     aTargets: [-1]
          // },
          // {
          //     "width": "10%",
          //     render: function (data, type, row) {
          //         // var strArray = data.split("_");
          //         // var id = strArray[8];
          //         // var status = strArray[1];
          //         // var active = '';
          //         // var unlock_icon = '';
          //         // if (status == 'active') {
          //         //     active = 'checked';
          //         // }
          //         // if(row.event=='account_locked' || row.login_attempts>4){
          //         //     unlock_icon = '<a href="#" data-tip="Unlock" data-id="' + id + '" class="btn btn-default actionBtn btn-delet" role="button" >' +
          //         //         '<i class="fa fa-unlock" aria-hidden="true"></i>' +
          //         //         '</a>';
          //         // }
          //         // return '<td ><a href="#" data-tip="Edit" data-id="' + id + '" class="btn btn-default actionBtn btn-edit" role="button">' +
          //         //     '<span class="glyphicon glyphicon-edit" aria-hidden="true"></span></a>&nbsp;     ' +
          //         //     '<a href="#" data-tip="Delete" data-id="' + id + '" class="btn btn-default actionBtn btn-delet" role="button" >' +
          //         //     '<span class="glyphicon glyphicon-remove" aria-hidden="true"></span>' +
          //         //     '</a>' +
          //         //     '<label class="switch">' +
          //         //     '<input type="checkbox" data-id="' + id + '" data-status="' + status + '" class="user_status" ' + active + '>' +
          //         //     '<span class="slider round"></span>' +
          //         //     '</label>' + unlock_icon
          //         //     +
          //         //     '</td>';
          //         // return '<td><ReactTooltip className="actionTooltip" place="bottom" type="dark" effect="solid"/>'+
          //         //         '<Link className="viewButton" data-tip="View Scheme"  to="/admin/admin-new-create-schemes-view/' + id + '"><span className="glyphicon glyphicon-eye-open" aria-hidden="true"></span></Link>' +
          //         //         '<Link className="viewButton" data-tip="Edit Scheme"  to="/admin/admin-new-create-schemes-edit/' + id + '"><span className="glyphicon glyphicon-edit" aria-hidden="true"></span></Link>' +
          //         //         '</td>';
          //         if(row.editable == '1' || row.editable == 1){
          //             return '<td>No</td>';
          //         }
          //         else{
          //             return '<td>Yes</td>'
          //         }
          //     },
          //     className: "action_button",
          //     targets: 7,
          //     aTargets: [-1]
          // },
          // {
          //     "width": "5%",
          //     render: function (data) {
          //         var strArray = data.split("$$");
          //         var id = strArray[0];
          //         var status = strArray[1];

          //         if (status == 'pending_approval' && that.state.luser_type == 'Internal' && that.state.lsub_group == 'Admin') {
          //             return '<td ><a href="#" data-tip="Approve" data-id="' + id + '" class="btn btn-default actionBtn btn-edit" role="button">' +
          //                 '<span class="glyphicon glyphicon-ok" aria-hidden="true"></span></a>&nbsp;     ' +

          //                 '</td>';
          //         } else {
          //             return '<td ></td>';
          //         }

          //     },
          //     className: "action_button",
          //     targets: 9,
          //     aTargets: [-1]
          // },


        ]
      });
    // $('#userTable').on('click', 'td.action_button .user_status', function (e) {
    //     e.stopImmediatePropagation();
    //     var id = $(this).data("id");
    //     var status = $(this).data("status");
    //     if (status == "pending") {
    //         alert("Please approve this user");
    //         return false;
    //     }
    //     that.changeStatus(this, id)
    // })
    // $('#userTable').on('click', 'td.action_button a', function (e) {
    //     e.stopImmediatePropagation();
    //     var id = $(this).data("id");
    //     var type = $(this).data("tip");
    //     if (type == 'Delete') {
    //         that.deleteUser(id);
    //     }
    //     if (type == 'Edit') {
    //         that.updUser(id, 'Edit User');
    //     }
    //     if (type == 'Approve') {
    //         that.updUser(id, 'Activate User');
    //     }
    //     if(type == 'Unlock') {
    //         that.unlockUser(id)
    //     }
    // })

    $('#campaignTable').on('change', 'td select', function (e) {
      if (this.value != '') {
        var fields = this.value.split('_');
        var name = fields[0];
        var id = fields[1];
        that.changeEmiType(name, id)
      }

    });
  }

  // uploadFilesData(promotion_id){
  //     this.setState({
  //         isSubmit: true,
  //         loading: true,

  //     });

  //     const token = localStorage.usertoken;
  //     const decoded = jwt_decode(token);
  //     // console.log(decoded);
  //     const data1 = new FormData();
  //     data1.append('promotion_id', promotion_id);
  //     //console.log(data1);
  //     axios.post(config.get('API_URL') + "/brandemi/promotion_subvention_return", data1,{
  //         headers: {
  //             Authorization: ` ${localStorage.usertoken}`
  //         }
  //     })
  //         .then(res => {
  //             //console.log(res.data.bank);
  //             //console.log(res.data.merchant);
  //             this.setState({
  //                 files_data: res.data,
  //                 bank_files: res.data.bank,
  //                 bank_count: res.data.bank.length,
  //                 brand_files: res.data.brand,
  //                 innoviti_files: res.data.innoviti,
  //                 merchant_files: res.data.merchant,
  //                 merchant_count: res.data.merchant.length,
  //                 campaignConfirmationModel: true,
  //                 promotion_id: promotion_id,
  //                 selectedFile1: null,
  //                 selectedFile2:null,
  //                 selectedFile3:null,
  //                 selectedFile4:null,
  //                 party_master_id: res.data.party_master_id
  //             });
  //             //console.log(res);
  //             this.setState({
  //                 isSubmit:false,
  //                 loading:false
  //             })
  //         })
  //         .catch(err => { // then print response status
  //             this.handleNotificationClick("tr", 3, "Something Wrong!");
  //             this.setState({
  //                 isSubmit:false,
  //                 loading:false
  //             })
  //         })
  // }

  // updatePartyType = (valuer) => {
  //     if (valuer.value == 'Merchant'){
  //         this.handleNotificationClick("tr", 3, "Merchant promotions is under construction.");
  //         // this.setState({
  //         //     selected_party_type: valuer.value,
  //         //     selected_party_type2: [{value: valuer.value, label: valuer.label}],
  //         //     uploadDropdown: false,
  //         //     upload_user_type: 2,
  //         //     loading: true,
  //         //     selected_party: null,
  //         //     selected_party2: null,
  //         //     party_list: [],
  //         //     party_master_id: 5,
  //         // }, () => {
  //         //     this.getPartyList();
  //         //     this._refreshCampaign();
  //         // });
  //     }
  //     else if( valuer.value == 'Brand'){
  //         this.setState({
  //             selected_party_type: valuer.value,
  //             selected_party_type2: [{value: valuer.value, label: valuer.label}],
  //             uploadDropdown: false,
  //             upload_user_type: 7,
  //             loading: true,
  //             selected_party: null,
  //             selected_party2: null,
  //             party_master_id: 5,
  //             party_list: []
  //         }, () => {
  //             this.getPartyList();
  //         });
  //     }
  // };

  // updatePartyValue = (valuer) => {
  //     this.setState({
  //         selected_party: valuer.value,
  //         selected_party2: [{value: valuer.value, label: valuer.label}],
  //         party_master_id: valuer.value,
  //         loading: false,
  //         uploadDropdown: false
  //     }, () => {
  //         this._refreshCampaign();
  //     });
  // };

  updatePartyType(optionSelected) {
    this.setState({
      loading: true
    })
    var value = '';
    var partyTypeArray = [];
    if (optionSelected.length < 1) {
      value = null;
      partyTypeArray = '';
    } else {
      optionSelected.map((partytypeids, i) => {
        partyTypeArray.push(partytypeids.value)
      });
    }
    this.setState({
      partyTypeID: partyTypeArray,
      partyTypeValue: optionSelected,
      uploadDropdown: false,
      // partyID: '',
      // partyValue: null,
      party_list: [],
      loading: false
    }, () => {
      this.getPartyList();
      this._refreshCampaign();
    });

    // this.setState({
    //     selected_party_type: valuer.value,
    //     selected_party_type2: [{value: valuer.value, label: valuer.label}],

    //     upload_user_type: 7,

    //     selected_party: null,
    //     selected_party2: null,
    //     party_master_id: 5,
    //     party_list: []
    // }, () => {
    //     this.getPartyList();
    // });

  };

  gotopm = () => {
    this.props.history.push('/admin/admin-promotion-master');
  }

  // sendApproveCampaign(){
  //     this.setState({
  //         upload_disabler: true
  //     });
  //     const timer1 = (Date.now()).toString();
  //     const data = new FormData();
  //     const token = localStorage.usertoken;
  //     const decoded = jwt_decode(token);
  //     var kill = 0;

  //     if(this.state.selectedFile1 == null){
  //         this.handleNotificationClick("tr", 3, "Please upload valid file");
  //         kill = 1;
  //     }

  //     if(this.state.innoviti_files == '1'){
  //         if(this.state.selectedFile2 == null){
  //             this.handleNotificationClick("tr", 3, "Please upload Innoviti files");
  //             kill = 1;
  //         }
  //         else{
  //             data.append('file2', this.state.selectedFile2);
  //             data.append('file2_stat', '1');
  //         }
  //     }
  //     else{
  //         data.append('file2', '');
  //         data.append('file2_stat', '');
  //     }

  //     var bank_counts = Number(this.state.bank_count);
  //     if(bank_counts > 0){
  //         if(this.state.selectedFile3 != null){
  //             var zlen = Object.keys(this.state.selectedFile3).length;
  //             if(Number(zlen) != bank_counts){
  //                 this.handleNotificationClick("tr", 3, "Please upload all bank files");
  //             }
  //             else{
  //                 for(var z = 0; z<zlen; z++) {
  //                     if(this.state.selectedFile3[z] == null){
  //                         this.handleNotificationClick("tr", 3, "Please upload all bank files");
  //                         kill = 1;
  //                         break;
  //                     }
  //                     data.append('file3', this.state.selectedFile3[z][0]);
  //                 }
  //                 data.append('file3_stat', '1');
  //             }
  //         }
  //         else{
  //             this.handleNotificationClick("tr", 3, "Please upload all bank files");
  //         }
  //     }
  //     else{
  //             data.append('file3', '');
  //             data.append('file3_stat', '');
  //     }

  //     var merchant_counts = Number(this.state.merchant_count);

  //     if(merchant_counts > 0){
  //         if(this.state.selectedFile4 != null){
  //             var wlen = Object.keys(this.state.selectedFile4).length;
  //             if(Number(wlen) != merchant_counts){
  //                 this.handleNotificationClick("tr", 3, "Please upload all merchant files");
  //             }
  //             else{
  //                 for(var w = 0; w<wlen; w++) {
  //                     if(this.state.selectedFile4[w] == null){
  //                         this.handleNotificationClick("tr", 3, "Please upload all merchant files");
  //                         kill = 1;
  //                         break;
  //                     }
  //                     data.append('file4', this.state.selectedFile4[w][0]);
  //                 }
  //                 data.append('file4_stat', '1');
  //             }
  //         }
  //         else{
  //             this.handleNotificationClick("tr", 3, "Please upload all merchant files");
  //         }
  //     }
  //     else{
  //         data.append('file4', '');
  //         data.append('file4_stat', '');
  //     }
  //     if(kill == 0){
  //         data.append('scheme_id', this.state.promotion_id);
  //         data.append('timer1', timer1);
  //         data.append('party_master_id', this.state.party_master_id);
  //         data.append('userID', decoded._id);
  //         data.append('file1', this.state.selectedFile1);
  //         data.append('merchant_files', JSON.stringify(this.state.merchant_files));
  //         data.append('bank_files', JSON.stringify(this.state.bank_files));
  //         data.append('brand_files', this.state.brand_files);
  //         axios.post(config.get('API_URL') + '/brandemi/submit_campaign_approve_master', data, {
  //             headers: {
  //                 Authorization: ` ${localStorage.usertoken}`
  //             }
  //         }).then(res => {
  //             this.handleNotificationClick("tr", 1, "File upload successful");
  //             //console.log(res.data);
  //             this.props.history.push('/admin/brand-emi');
  //             //this.gotopm();
  //         }).catch(err => {
  //             this.handleNotificationClick("tr", 3, "Something wrong! Please retry after few moments");
  //         })
  //     }
  //     else{
  //         this.setState({
  //             upload_disabler: false
  //         });
  //     }
  // }

  updatePartyValue(optionSelected) {
    //console.log(optionSelected);
    this.setState({
      loading: true
    })
    var value = '';
    var partyArray = [];
    if (optionSelected.length < 1) {
      value = null;
      partyArray = '';
    } else {
      optionSelected.map((partyids, i) => {
        partyArray.push(partyids.value)
      });
    }
    this.setState({
      partyID: partyArray,
      partyValue: optionSelected,
      uploadDropdown: false,
      loading: false
    }, () => {
      this._refreshCampaign();
    });

    // this.setState({
    //     selected_party: valuer.value,
    //     selected_party2: [{value: valuer.value, label: valuer.label}],
    //     party_master_id: valuer.value,
    //     loading: false,
    //     uploadDropdown: false
    // }, () => {
    //     this.getBrandUploadedData();
    // });
  };

  changeEmiType(name, id) {
    axios.post(config.get('API_URL') + '/brandemi/select-emi-type', {
        promotion_id: id,
        emi_type: name
      },
      {
        headers: {
          Authorization: ` ${localStorage.usertoken}`
        }
      })
      .then(response => { //console.log(response);
        this.handleNotificationClick("tr", 1, "Success");
      });

  }

  getPartyList() {
    const token = localStorage.usertoken;
    axios.post(config.get('API_URL') + '/brandemi/get_party_list_filter', {
        party_type: this.state.partyTypeID
      },
      {
        headers: {
          Authorization: ` ${localStorage.usertoken}`
        }
      })
      .then(response => { //console.log(response);
        var party_list = [];
        this.setState({
          party_list: [],
          selected_party: null
        });
        response.data.data.map((values, index) => {
          if (values.party_name != 'Admin') {
            party_list.push({value: values.id, label: values.party_name})
          }
        });
        this.setState({
          party_list: party_list,
          loading: false
        })
      });
  }

  mapData(id, map_status, stored_file_name, user_type, user_id, file_name) {
    this.setState({
      id: id,
      map_status: map_status,
      stored_file_name: stored_file_name,
      userGroup: user_type,
      user_id: user_id,
      file_name: file_name
    });
    this.openSectionToMap(true);
  }

  goBack = () => {
    this.props.history.push('/admin/brand-emi')
  }

  openSectionToMap = (status) => {
    //console.log(this.state.userGroup);
    this.setState({
      mapField: status
    })
  };

  updateMapVisiblity = (value) => {
    //console.log(JSON.stringify(value));
    this.setState({
      mapField: value
    })
  };


  _onEmiChecked() {
    this.setState({
      partyTypeValue: [],
      partyValue: [],
      displaySchemeDiv: 'block',
      enableDisablePartyType: 'block'
    })

    localStorage.setItem('locPromoFlexipay', '0');

    this._refreshCampaign();
  }

  _onFlexypayChecked() {

    this.setState({
      partyTypeValue: [{value: "Brand", label: "Brand"}],
      partyValue: [{value: 35, label: "Default"}],
      displaySchemeDiv: 'block',
      enableDisablePartyType: 'none'
    })

    localStorage.setItem('locPromoFlexipay', '1');
    this._refreshCampaign();
  }

  render() {
    // console.log(this.state.campaign_response);
    // if(this.state.selectedFile4 != null){
    //     console.log(this.state.selectedFile4.length);
    //     console.log(this.state.selectedFile4[0]);
    //     console.log(this.state.selectedFile4[0][0]);
    // }
    const MenuList = props => {
      const rows = props.children;
      var no_of_rows = 0;
      var drop_down_heigth = 0
      if (rows.length !== undefined) {
        no_of_rows = rows.length;
        if (no_of_rows < 9) {
          drop_down_heigth = 40 * no_of_rows;
        } else {
          drop_down_heigth = 300;
        }

      }
      const rowRenderer = ({key, index, isScrolling, isVisible, style}) => (
        <div key={key} style={style}>{rows[index]}</div>
      );

      return (
        <List
          style={{width: '100%'}}
          width={300}
          height={drop_down_heigth}
          rowHeight={30}
          rowCount={no_of_rows}
          rowRenderer={rowRenderer}
        />
      )
    }
    const customStyles = {
      control: provided => ({
        ...provided,
        padding: "0px",
        minHeight: "15px",
      }),
      indicatorsContainer: provided => ({
        ...provided,
        height: "23px"
      }),
      clearIndicator: provided => ({
        ...provided,
        padding: "5px"
      }),
      dropdownIndicator: provided => ({
        ...provided,
        padding: "5px"
      }),
      valueContainer: base => ({
        ...base,
        padding: '0px 6px'
      }),
      menu: styles => ({...styles, zIndex: 999})
    };


    var party_render = this.state.party_options;
    var party_render_list = this.state.party_list;
    const token = localStorage.usertoken;
    const decoded = jwt_decode(token);

    // var brand_upload_displayer = () => {
    //     return(
    //             <div className="row">
    //                 <div className="col-md-12">
    //                     <div className="form-group form-bottom">
    //                         <label htmlFor="queryName1" className="pull-centere">Upload File for {this.state.brand_files}</label>
    //                         <input type="file" name="brand_file" className="form-control pull-centere" onChange={this.onChangeHandler1} />
    //                     </div>
    //                 </div>
    //             </div>
    //             )
    // }

    // var innoviti_upload_displayer = () => {
    //     if(this.state.innoviti_files == 1 || this.state.innoviti_files == '1'){
    //         return(
    //             <div className="row">
    //                 <div className="col-md-12">
    //                     <div className="form-group form-bottom">
    //                         <label htmlFor="queryName1" className="pull-centere">Upload File for Innoviti</label>
    //                         <input type="file" name="innoviti_file" className="form-control pull-centere" onChange={this.onChangeHandler2} />
    //                     </div>
    //                 </div>
    //             </div>
    //         )
    //     }
    // }

    // var bank_upload_displayer = this.state.bank_files.map((values, index) => {
    //         return(
    //             <div key={index} className="row">
    //                 <div className="col-md-12">
    //                     <div className="form-group form-bottom">
    //                         <label htmlFor="queryName1" className="pull-centere">Upload File for {values}</label>
    //                         <input key={index} type="file" name={"bank_" + values} className="form-control pull-centere" onChange={this.onChangeHandler3.bind(this, index)} />
    //                     </div>
    //                 </div>
    //             </div>
    //         )
    //     })

    // var merchant_upload_displayer = this.state.merchant_files.map((values, index) => {
    //     return(
    //         <div key={index+"_"} className="row">
    //             <div className="col-md-12">
    //                 <div className="form-group form-bottom">
    //                     <label htmlFor="queryName1" className="pull-centere">Upload File for {values}</label>
    //                     <input key={index} type="file" name={"merchant_" + values} className="form-control pull-centere" onChange={this.onChangeHandler4.bind(this,index)} />
    //                 </div>
    //             </div>
    //         </div>
    //     )
    // });

    var party_shower = () => {
      if (decoded.userGroup == 1 || decoded.userGroup == '1') {
        return (
          <div className="row top-margin-30" style={{display: this.state.enableDisablePartyType}}>
            <div className="col-md-3">
              <Label>Select party type</Label>
              <ReactMultiSelectCheckboxes name={"party_type_filter"}
                                          components={{MenuList}}
                                          value={this.state.partyTypeValue}
                                          styles={customStyles} className="report-listbox"
                                          onChange={this.updatePartyType.bind(this)}
                                          options={party_render}
                                          placeholderButtonLabel="Select [Party Type]"
                // isClearable={true}

              />
            </div>
            <div className="col-md-3">
              <Label>Select party</Label>
              <ReactMultiSelectCheckboxes name={"party_name_filter"}
                                          components={{MenuList}}
                                          value={this.state.partyValue}
                                          styles={customStyles} className="report-listbox"
                                          onChange={this.updatePartyValue.bind(this)}
                                          options={party_render_list}
                                          placeholderButtonLabel="Select [Party Name]"
                // isClearable={true}
              />
            </div>
          </div>
        )
      } else {
        return (
          <div></div>
        )
      }
    };

    // var campaign_data = this.state.campaign_response.map((value,index) => {
    //     var Activer = 'Created';
    //     var edit_activer = false;
    //     var timer = new Date(value.start_date).toJSON().slice(0, 10).replace('T', ' ');
    //     var timer1 = new Date(value.end_date).toJSON().slice(0, 10).replace('T', ' ');
    //     timer = moment(timer).format('YYYY-MM-DD');
    //     timer1 = moment(timer1).format('YYYY-MM-DD');
    //     var timer2 = new Date(value.record_update_timestamp);
    //     timer2.setHours( timer2.getHours() + 5 );
    //     timer2.setMinutes( timer2.getMinutes() + 30 );
    //     // timer
    //     var timer3 = timer2.toJSON().slice(0, 19).replace('T', ' ');
    //     if (value.active != 0 || value.active != '0')
    //     {
    //         if (value.active == -1 || value.active == '-1'){
    //             Activer = 'Rejected';
    //             edit_activer=true;
    //         }
    //         else if (value.active == 2 || value.active == '2'){
    //             Activer = 'Configured';
    //             edit_activer=true;
    //         }
    //         else if (value.active == 3 || value.active == '3'){
    //             Activer = 'QA Verified';
    //             edit_activer=true;
    //         }
    //         else if ((value.active == 4 || value.active == '4') && (value.flag == '1' || value.flag == 1)){
    //             Activer = 'Automated';
    //             edit_activer=true;
    //         }
    //         else if ((value.active == 4 || value.active == '4') && (value.flag == '-1' || value.flag == -1)){
    //             Activer = 'API Failure';
    //             edit_activer=true;
    //         }
    //         else if ((value.active == 4 || value.active == '4') && (value.flag == '-2' || value.flag == -2)){
    //             Activer = 'Timed Out';
    //             edit_activer=true;
    //         }
    //         else if (value.active == 4 || value.active == '4'){
    //             Activer = 'Ready';
    //             edit_activer=true;
    //         }
    //         else if (value.active == 1 || value.active == '1'){
    //             Activer = 'Approved';
    //             edit_activer=true;
    //         }
    //         else{
    //             Activer = 'Expired';
    //             edit_activer=true;
    //         }

    //         return (
    //             <tr key={index + 1}>
    //                 <td>{value.party_type}</td>
    //                 <td>{value.party_name}</td>
    //                 <td>{value.campaign_name}</td>
    //                 <td>{value.campaign_desc}</td>
    //                 <td>{value.start_date}</td>
    //                 <td>{value.end_date}</td>
    //                 <td>{timer3}</td>
    //                 <td>{Activer}</td>
    //                 <td>
    //                     <ReactTooltip className='actionTooltip' place="bottom" type="dark" effect="solid"/>
    //                     <Link className="viewButton" data-tip="View Promotion Summary"  to={"/admin/admin-view-promotion1/" + value.id}><span className="glyphicon glyphicon-eye-open" aria-hidden="true"></span></Link>
    //                 </td>
    //             </tr>
    //         );
    //     }
    //     else{

    //         return (
    //             <tr key={index + 1}>
    //                 <td>{value.party_type}</td>
    //                 <td>{value.party_name}</td>
    //                 <td>{value.campaign_name}</td>
    //                 <td>{value.campaign_desc}</td>
    //                 <td>{value.start_date}</td>
    //                 <td>{value.end_date}</td>
    //                 <td>{timer3}</td>
    //                 <td>{Activer}</td>
    //                 <td>
    //                     <ReactTooltip className='actionTooltip' place="bottom" type="dark" effect="solid"/>
    //                     <Link className="viewButton" data-tip="View Promotion Summary"  to={"/admin/admin-view-promotion1/" + value.id}><span className="glyphicon glyphicon-eye-open" aria-hidden="true"></span></Link>
    //                     <Link className="viewButton" disabled={edit_activer} data-tip="Edit Promotion"  to={"/admin/admin-edit-promotion/" + value.id}><span className="glyphicon glyphicon-edit" aria-hidden="true"></span></Link>
    //                     {/* <Link className="viewButton" disabled={edit_activer} data-tip="Upload Files"  onClick={this.uploadFilesData.bind(this, value.id)}><span className="glyphicon glyphicon-upload" aria-hidden="true"></span></Link> */}
    //                 </td>
    //             </tr>
    //         );
    //     }
    // });

    return (
      <div className="longcontent">
        <CommonNavbar/>
        <div className="container-fluid">


          <div className="card-query-builder">
            <NotificationSystem ref="notificationSystem" style={style}/>
            <ReactTooltip/>
            {/* <Modal className="modalsmall" isOpen={this.state.campaignConfirmationModel}
                toggle={this.toggleCampaignModel.bind(this)}
                size = "sm"
                >
                    <ModalBody>
                        <div className="row">
                            <div className="col-xs-12 ">
                                <h4 className="modalh4"> Are you sure you want to approve?</h4>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-xs-12 col-md-12">
                                Valid files are: .doc, .docx, .csv, .jpg, .jpeg, .png, .xls, .xlsx, .pdf, .eml, .zip and .txt
                            </div>
                        </div>
                        <hr/>
                        <div className="row">

                        </div>
                        {brand_upload_displayer()}
                        {bank_upload_displayer}
                        {merchant_upload_displayer}
                        {innoviti_upload_displayer()}
                        <ModalFooter>
                            <Button color="primary" disabled={this.state.upload_disabler} className="btn btn-primary btn-capitalize" onClick={this.sendApproveCampaign.bind(this)}>Upload Files</Button>{' '}
                            <Button color="secondary" disabled={this.state.upload_disabler} className="btn btn-primary btn-capitalize2" onClick={this.toggleCampaignModel.bind(this)}>Cancel</Button>
                        </ModalFooter>
                    </ModalBody>
                </Modal> */}

            <div className="card" style={{marginBottom: '-2px', paddingLeft: '10px'}}>
              <input type="radio" name="same" onChange={this._onEmiChecked.bind(this)}/><small>EMI</small>
              &nbsp; &nbsp; &nbsp;
              <input type="radio" name="same" onChange={this._onFlexypayChecked.bind(this)}/><small>Flexipay</small>
            </div>

            <div className="pt-5" style={{display: this.state.displaySchemeDiv}}>
              <div className="card " ref={this.myRef}>

                <div className="header">

                  <h4 className="title pull-left">Promotions</h4>
                  <button onClick={this.campaignDropdown} className="btn btn-primary btn-capitalize pull-right">Create
                    New
                  </button>

                </div>

                <div className="content">
                  <div className='sweet-loading'>
                    <BeatLoader
                      css={override}
                      sizeUnit={"px"}
                      size={20}
                      color={'#123abc'}
                      loading={this.state.loading}
                    />
                  </div>
                  {/* <div className="col-md-12">

                            </div> */}
                  {party_shower()}
                  <div className="row">
                    <div className="content table-full-width table-responsive">
                      <table className="table table-striped table-hover" id="campaignTable">
                        <thead>
                        <tr>
                          <th>Party Type</th>
                          <th>Party Name</th>
                          <th>Promotion Name</th>
                          <th>Promotion Description</th>
                          <th>Start Date</th>
                          <th>End Date</th>
                          <th>Update Timestamp</th>
                          <th>Status</th>
                          <th width="60px">Action</th>
                        </tr>
                        </thead>
                        <tbody>
                        {/* {campaign_data} */}
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <div className="footer">
                    <div className="stats"><i></i></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}


export default AdminPromotionMasterBackend;